import { render, staticRenderFns } from "./ProgramasServicos.vue?vue&type=template&id=f8690d6e"
import script from "./ProgramasServicos.vue?vue&type=script&lang=js"
export * from "./ProgramasServicos.vue?vue&type=script&lang=js"
import style0 from "./ProgramasServicos.vue?vue&type=style&index=0&id=f8690d6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports